import { createServerFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'
import { auth } from '@server/auth'

/**
 * Server function to check if the current user has admin access.
 * Honors ADMIN_USER_IDS environment variable and Better Auth admin plugin.
 */
export const checkAdminAccess = createServerFn({ method: 'GET' }).handler(
  async () => {
    const request = getRequest()
    const adminUserIds = (process.env.ADMIN_USER_IDS || '')
      .split(',')
      .filter(Boolean)

    // Get the session to extract the user ID
    const session = await auth.api.getSession({ headers: request.headers })

    if (!session?.user) {
      return false
    }

    const userId = session.user.id

    // Check if user ID is in the admin list (highest priority)
    // This is the most direct check and bypasses permission system
    if (adminUserIds.includes(userId)) {
      return true
    }

    // Check if user has admin permissions using Better Auth's permission system
    // Now that we've separated access controls, hasPermission should work correctly
    // for admin plugin permissions (user, session resources)
    const hasAdminPermission = await auth.api.hasPermission({
      headers: request.headers,
      body: {
        permissions: {
          user: ['list'], // Admin plugin permission
        },
      },
    })

    // hasPermission returns true, { hasPermission: true }, or false
    return (
      hasAdminPermission === true || hasAdminPermission.hasPermission === true
    )
  },
)
